export default __webpack_public_path__ + "static/media/erroricon.351b40b2.svg";